import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { catchError, retry } from 'rxjs/operators';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { PaymentRequestActionData } from '../../event/models/payment-request-action-data';
import { Constants } from '../../shared/constants';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { PaymentRequest } from '../model/payment-request';

@Injectable()
export class CommissionService {

  eventsGetUrl: string = this.environment.baseUrl + '/api/commissions/events';
  approvePostUrl: string = this.environment.baseUrl + '/api/commissions/approve';
  rejectPostUrl: string = this.environment.baseUrl + '/api/commissions/reject';

  constructor(
    private httpClient: HttpClient,
    private environment: EnvironmentConfiguration,
    private responseUtilService: ResponseUtilService,
  ) { }

  getPaymentRequestDetails(): Observable<PaymentRequest | Response> {
    const options = this.buildHttpHeaders();
    return this.httpClient.get<PaymentRequest>(this.eventsGetUrl, options)
      .pipe(
        retry(1));
  }

  approvePaymentRequest(email: string): Observable<any> {
    const options = this.buildHttpHeaders();
    const request = new PaymentRequestActionData({
      email: email,
      reason: null,
      details: null
    });
    const requestAsJSON = JSON.stringify(request);
    return this.httpClient.post(this.approvePostUrl, requestAsJSON, options)
      .pipe(
        retry(1),
        catchError(err => this.responseUtilService.handleError(err)));
  }

  rejectPaymentRequest(email: string, reason: string, details: string): Observable<any> {
    const options = this.buildHttpHeaders();
    const request = new PaymentRequestActionData({
      email: email,
      reason: reason,
      details: details
    });
    const requestAsJSON = JSON.stringify(request);
    return this.httpClient.post(this.rejectPostUrl, requestAsJSON, options)
      .pipe(
        retry(1),
        catchError(err => this.responseUtilService.handleError(err)));
  }

  private buildHttpHeaders() {
    let token = localStorage.getItem(Constants.COMMISSION_TOKEN_KEY);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });
    let options = { headers: headers };
    return options;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/service/commission.service.ts